var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 36,
    viewBox: "0 0 56 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2H48C48.5523 2 49 2.44771 49 3V32H51V3C51 1.34315 49.6569 0 48 0H8C6.34315 0 5 1.34315 5 3V32H7V3C7 2.44772 7.44771 2 8 2ZM3 34H0C0 35.1046 0.89543 36 2 36H5H7H49H51H54C55.1046 36 56 35.1046 56 34H53H51H49H32C32 34.5523 31.5523 35 31 35H25C24.4477 35 24 34.5523 24 34H7H5H3Z",
    fill: "#878787"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktop);
export default __webpack_public_path__ + "static/media/desktop.6601d9e424ef0c1f96520bb77d7715a2.svg";
export { ForwardRef as ReactComponent };